import React, { useEffect, useRef } from 'react';
import useIsMobile from '../hooks/useIsMobile';

const NeuralCanvas = () => {
  const canvasRef = useRef(null);
  const isMobile = useIsMobile();
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let particles = [];
    const particleCount = isMobile ? 50 : 75;
    const connectionDistance = isMobile ? 70 : 100;

    const initCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      particles = [];
      for (let i = 0; i < particleCount; i++) {
        particles.push(new Particle(canvas));
      }
    };

    class Particle {
      constructor(canvas) {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.radius = isMobile ? 
          Math.random() * 1 + 0.3 : 
          Math.random() * 1.5 + 0.5;
        const speed = isMobile ? 1 : 2;
        this.speedX = (Math.random() - 0.5) * speed;
        this.speedY = (Math.random() - 0.5) * speed;
      }

      update() {
        this.x += this.speedX;
        this.y += this.speedY;

        if (this.x < 0 || this.x > canvas.width) this.speedX *= -1;
        if (this.y < 0 || this.y > canvas.height) this.speedY *= -1;
      }

      draw(ctx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${isMobile ? 0.6 : 0.8})`;
        ctx.fill();
      }
    }

    const connectParticles = () => {
      particles.forEach((p1, i) => {
        for (let j = i + 1; j < particles.length; j++) {
          const p2 = particles[j];
          const dist = Math.hypot(p1.x - p2.x, p1.y - p2.y);
          if (dist < connectionDistance) {
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.strokeStyle = `rgba(255, 255, 255, ${1 - dist / connectionDistance})`;
            ctx.lineWidth = isMobile ? 0.3 : 0.5;
            ctx.stroke();
          }
        }
      });
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.update();
        p.draw(ctx);
      });
      connectParticles();
      requestAnimationFrame(animate);
    };

    initCanvas();
    animate();

    window.addEventListener('resize', initCanvas);

    return () => {
      window.removeEventListener('resize', initCanvas);
    };
  }, [isMobile]);

  return <canvas ref={canvasRef} id="neuralCanvas" />;
};

export default NeuralCanvas; 